module.exports = __webpack_public_path__ + "static/media/SmartphoneApp.f384b573.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/SmartphoneApp.svg
// module id = 404
// module chunks = 0